import { Button } from "reactstrap"

/**
 * Toggle button for "mark this row as added/present" style flows (e.g. the
 * Daily Vehicle Audit checklist). Reusable wherever a boolean row-state
 * needs a click-to-toggle affordance instead of a checkbox.
 */
const MarkAddedButton = ({ marked, onToggle, size = "sm", markedLabel = "Added", unmarkedLabel = "Mark as Added", disabled = false }) => (
  <Button
    type="button"
    color={marked ? "success" : "light"}
    outline={!marked}
    size={size}
    onClick={onToggle}
    disabled={disabled}
  >
    <i className={`mdi ${marked ? "mdi-check-circle" : "mdi-circle-outline"} me-1`} />
    {marked ? markedLabel : unmarkedLabel}
  </Button>
)

export default MarkAddedButton
